import(/* webpackMode: "eager", webpackExports: ["CopilotLayoutClient"] */ "/vercel/path0/apps/frontend/src/components/Copilot/CopilotLayoutClient.tsx");
